import { Menu } from 'lucide-react'
import { NavLink } from 'react-router-dom'

import { useTemVisitasAbertas } from '@/features/operacional/minhasVisitas/hooks/useMinhasVisitas'
import { possuiPapel, ROLES } from '@/lib/auth/roles'
import { useAuthStore } from '@/stores/authStore'
import { cn } from '@/utils/cn'

import { NAV_SECTIONS } from './navItems'

interface MobileNavProps {
  onOpenMenu: () => void
}

// Célula com altura fixa e conteúdo centralizado — mantém ícone e texto
// alinhados mesmo quando um rótulo mais longo (ex.: "Contracheque") quebra em
// duas linhas em telas estreitas.
const CELL =
  'flex min-h-14 min-w-0 flex-1 flex-col items-center justify-center gap-1 px-1 py-1.5 ' +
  'text-center text-[0.68rem] font-medium leading-tight transition-colors duration-200'

// Palavra única maior que a célula ("Colaboradores") hifeniza em vez de invadir a vizinha.
const LABEL = 'line-clamp-2 w-full hyphens-auto [overflow-wrap:anywhere]'

export function MobileNav({ onOpenMenu }: MobileNavProps) {
  const papeis = useAuthStore((state) => state.user?.papeis)
  const isRh = possuiPapel(papeis, [ROLES.RH])
  const temVisitas = useTemVisitasAbertas()

  const allItems = NAV_SECTIONS.flatMap((section) => section.items)
  const inicio = allItems.find((item) => item.to === '/')!
  const contraCheque = allItems.find((item) => item.to === '/contracheque')!
  const COLABORADORES = allItems.find((item) => item.to === '/rh/colaboradores')!
  const perfil = allItems.find((item) => item.to === '/meu-perfil')!
  const visitas = allItems.find((item) => item.to === '/minhas-visitas')!

  const items = [
    inicio,
    ...(temVisitas ? [visitas] : []),
    ...(isRh ? [COLABORADORES] : []),
    contraCheque,
    perfil,
  ]

  return (
    <nav className="fixed inset-x-0 bottom-0 z-20 border-t border-line bg-surface/95 pb-[env(safe-area-inset-bottom)] backdrop-blur lg:hidden">
      <div className="mx-auto flex max-w-lg items-stretch">
        {items.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) => cn(CELL, isActive ? 'text-brand' : 'text-fg-muted')}
          >
            {({ isActive }) => (
              <>
                <item.icon
                  className={cn(
                    'size-5 shrink-0 transition-transform duration-200',
                    isActive && '-translate-y-0.5 scale-110',
                  )}
                />
                <span className={LABEL}>{item.label}</span>
              </>
            )}
          </NavLink>
        ))}
        <button
          type="button"
          onClick={onOpenMenu}
          className={cn(CELL, 'text-fg-muted hover:text-fg')}
        >
          <Menu className="size-5 shrink-0" />
          <span className={LABEL}>Menu</span>
        </button>
      </div>
    </nav>
  )
}
